import { DocumentContentRowProps, labels } from '../documentsPageCommon';

export function DocumentContentRow({
  labelKey,
  content,
  contentClass,
  labelClass,
  isMaskingEnabled
}: DocumentContentRowProps): JSX.Element {
  return (
    <div key={labelKey} className={`col-12 label-value`}>
      <label className={`col-6 ${labelClass || ''}`}>{labels[labelKey]}</label>
      <span className={`col-6 ${contentClass || ''}`} data-dd-privacy={isMaskingEnabled ? 'mask' : 'allow'}>
        {content}{' '}
      </span>
    </div>
  );
}
